import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFormPyramide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"form-pyramide, prism"} maskId="square-filled-radius-0-stroke-1-IconFormPyramide"><path fillRule="evenodd" clipRule="evenodd" d="M23.2578 16.165L22.7285 16.4434L12.2285 21.9434L11.9961 22.0645L11.7637 21.9434L1.26367 16.4434L0.734375 16.165L11.9961 1.68555L23.2578 16.165ZM11.9961 20.9346L21.7334 15.834L11.9961 3.31348V20.9346Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconFormPyramide;
